'use strict';

$(function() {
  // initialize
  // methods
  function categoryCarouselPageLoad() {
    var originalSlider;
    var carouselOptions = {
      minSlides: 1,
      maxSlides: 1,
      responsive: true,
      infiniteLoop: true,
      pager: false,
      touchEnabled: false,
      startSlide: 0,
      prevSelector: '.bxslider-carousel__homepage-prev',
      nextSelector: '.bxslider-carousel__homepage-next',
      onSliderLoad: function onSliderLoaded(currentIndex) {
        categorySliderLoaded($('.category-carousel'));
      },
      onSlideBefore: function onSlideBefore($slideElm, oldIndex, newIndex) {
        slideBefore($('.category-carousel'), newIndex);
        $slideElm.attr('data-curSlide', newIndex);
      },
      onSlideAfter: function onSlideAfter($slideElm, oldIndex, newIndex) {
        SlideAfter($('.category-carousel'));
      }
    };
    $.fn.chunk = function chunk(size) {
      var arr = [];

      for (var i = 0; i < this.length; i += size) {
        arr.push(this.slice(i, i + size));
      }

      return this.pushStack(arr, 'chunk', size);
    };

    function resizeCategoryCarousel() {
      var carouselOutterWidth = $(
        '.category-carousel-mobile-wrapper'
      ).innerWidth();
      if (originalSlider) {
        if ($('.category-carousel-slide').length > 0) {
          originalSlider.destroySlider();
          $('.category-carousel-slide').each(function(index, item) {
            var content = $(item).contents();
            $(item).replaceWith(content);
          });
          if (carouselOutterWidth < 768) {
            carouselOptions.slideMargin = 0;
            $('.category-carousel > .item')
              .chunk(1)
              .wrap(
                '<div class="category-carousel-slide slide row d-flex ml-0"></div>'
              );
          } else {
            carouselOptions.slideMargin = 10;
            $('.category-carousel > .item')
              .chunk(3)
              .wrap(
                '<div class="category-carousel-slide slide row d-flex ml-0"></div>'
              );
          }
          originalSlider = $('.category-carousel').bxSlider(carouselOptions);
        }
      }
    }

    function categorySliderLoaded(slider) {
      $('.bx-clone').attr('tabindex', '-1');
      $(slider)
        .find('.category-carousel-slide')
        .not('.bx-clone')
        .eq(0)
        .addClass('current');
      arrangeCurrentSlide(slider);

      $(slider)
        .find('.category-carousel-slide')
        .not('.current')
        .find('a')
        .attr('tabindex', '-1');
      $(slider)
        .find('.bx-prev')
        .attr('tabindex', '0');
      $(slider)
        .find('.bx-next')
        .attr('tabindex', '0');
    }

    function slideBefore(slider, curSlideIndex) {
      $(slider)
        .find('.category-carousel-slide')
        .removeClass('current')
        .width($('.category-carousel-mobile-wrapper').innerWidth())
        .css('justify-content', 'center');
      $(slider)
        .find('.category-carousel-slide:not(.bx-clone)')
        .eq(curSlideIndex)
        .addClass('current');

      $(slider)
        .find('.category-carousel-slide')
        .not('.current')
        .find('a')
        .attr('tabindex', '-1');
      $(slider)
        .find('.current a')
        .attr('tabindex', '0');
    }

    function arrangeCurrentSlide(slider) {
      var carouselOutterWidth = $(
        '.category-carousel-mobile-wrapper'
      ).innerWidth();
      var width = $(slider)
        .find('.category-carousel-slide.current .item')
        .width();
      //Move previous slide to the end of the slide
      $($(slider).find('.category-carousel-slide.current'))
        .prev()
        .css('justify-content', 'flex-end');
      //Move next slide to the start of the slide
      $($(slider).find('.category-carousel-slide.current'))
        .next()
        .css('justify-content', 'flex-start');
      $('.category-carousel-mobile-wrapper .bx-next').attr(
        'aria-label',
        'Next arrow icon graphic'
      );
      $('.category-carousel-mobile-wrapper .bx-prev').attr(
        'aria-label',
        'Previous arrow icon graphic'
      );

      if (carouselOutterWidth > 767) {
        var matrix = $('.category-carousel')
          .css('transform')
          .replace(/[^0-9\-.,]/g, '')
          .split(',');
        var extraWidth = carouselOutterWidth - width * 3;
        //reducing current slide width
        $($(slider).find('.category-carousel-slide.current')).css(
          'width',
          width * 3 + 'px'
        );

        //Transforming carousel according to extra width after reducing current slide width
        $('.category-carousel').css(
          'transform',
          'translate3d(' +
            (parseInt(matrix[12] || matrix[4], 10) + extraWidth / 2) +
            'px, ' +
            parseInt(matrix[13] || matrix[5], 10) +
            'px, 0)'
        );
        width = $(
          $(slider).find('.category-carousel-slide.current .item')
        ).width();

        //Using extra width after resizing current slide for positioning of prev and next arrows
        extraWidth =
          $($(slider).find('.category-carousel-slide.current')).outerWidth() -
          width * 3 +
          10;

        if (carouselOutterWidth < 1024) {
          $('.category-carousel-mobile-wrapper .bx-prev').css(
            'left',
            extraWidth / 3.3
          );
          $('.category-carousel-mobile-wrapper .bx-next').css(
            'right',
            extraWidth / 3.3
          );
        } else if (carouselOutterWidth < 1367) {
          $('.category-carousel-mobile-wrapper .bx-prev').css(
            'left',
            extraWidth / 2
          );
          $('.category-carousel-mobile-wrapper .bx-next').css(
            'right',
            extraWidth / 2
          );
        } else {
          $('.category-carousel-mobile-wrapper .bx-prev').css(
            'left',
            extraWidth / 1.5
          );
          $('.category-carousel-mobile-wrapper .bx-next').css(
            'right',
            extraWidth / 1.5
          );
        }
      } else {
        extraWidth =
          $($(slider).find('.category-carousel-slide.current')).width() - width;
        $('.category-carousel-mobile-wrapper .bx-prev').css(
          'left',
          extraWidth / 4
        );
        $('.category-carousel-mobile-wrapper .bx-next').css(
          'right',
          extraWidth / 4
        );
      }
    }

    function SlideAfter(slider) {
      $(slider)
        .find('.category-carousel-slide')
        .not('.current')
        .find('a')
        .attr('tabindex', '-1');
      $(slider)
        .find('.current a')
        .attr('tabindex', '0');
      arrangeCurrentSlide(slider);
    }

    var carouselOutterWidth = $(
      '.category-carousel-mobile-wrapper'
    ).innerWidth();
    if (carouselOutterWidth < 768) {
      carouselOptions.slideMargin = 0;
      $('.category-carousel > .item')
        .chunk(1)
        .wrap(
          '<div class="category-carousel-slide slide row d-flex ml-0"></div>'
        );
    } else {
      carouselOptions.slideMargin = 10;
      $('.category-carousel > .item')
        .chunk(3)
        .wrap(
          '<div class="category-carousel-slide slide row d-flex ml-0"></div>'
        );
    }
    originalSlider = $('.category-carousel').bxSlider(carouselOptions);

    $(window).on('resize', resizeCategoryCarousel);
  }

  categoryCarouselPageLoad();
});
